import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ClaimsService } from '../services/claims.service';

@Injectable()
export class PaygGuard {

    constructor(
        private router: Router,
        private claimsService: ClaimsService
    ) { }

    canActivate() {
        const hasPaygRole = this.claimsService.hasPaygFeature() || this.claimsService.isSuperUser();
        if (!hasPaygRole) {
            this.router.navigate(['/auth/logout']);
        }
        return hasPaygRole;
    }
}
